export default __webpack_public_path__ + "static/media/zrItJqWTRXGNZJ2OFfwf_telegram.adb54024.jpg";